export default function HrPayroll() {
    return (
      <div className="p-6 bg-white rounded-xl shadow space-y-6">
        <h1 className="text-3xl font-bold text-gray-700">Payroll</h1>
        <p className="text-gray-500">Manage salaries, bonuses, and payslips.</p>
        <div className="overflow-x-auto">
          <table className="min-w-full table-auto border border-gray-200">
            <thead className="bg-gray-100">
              <tr>
                <th className="p-3 border">Employee Name</th>
                <th className="p-3 border">Month</th>
                <th className="p-3 border">Salary</th>
                <th className="p-3 border">Status</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="p-3 border">John Doe</td>
                <td className="p-3 border">Dec 2025</td>
                <td className="p-3 border">$5,000</td>
                <td className="p-3 border text-green-500 font-semibold">Paid</td>
              </tr>
              <tr>
                <td className="p-3 border">Jane Smith</td>
                <td className="p-3 border">Dec 2025</td>
                <td className="p-3 border">$4,500</td>
                <td className="p-3 border text-red-500 font-semibold">Pending</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  }
  